import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import _ from 'underscore'
import Moment from 'moment'

import { extendMoment } from 'moment-range'
import Spektrix from './spektrix'

const moment = extendMoment(Moment)
// import moment_en from 'moment/locale/en-gb'
// import moment_cy from 'moment/locale/cy'

class Days extends Component {

    constructor(props) {

        super(props)

        // console.log('CAL', props.calendar)
        if (ajax_client.current_lang == 'cy') {

            moment.locale(ajax_client.current_lang, {
                months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
                    '_'
                ),
                monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
                    '_'
                ),
                weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                    '_'
                ),
                weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
                weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
                weekdaysParseExact: true,
                // time formats are the same as en-gb
                // longDateFormat: {
                //     LT: 'HH:mm',
                //     LTS: 'HH:mm:ss',
                //     L: 'DD/MM/YYYY',
                //     LL: 'D MMMM YYYY',
                //     LLL: 'D MMMM YYYY HH:mm',
                //     LLLL: 'dddd, D MMMM YYYY HH:mm',
                // },
                // calendar: {
                //     sameDay: '[Heddiw am] LT',
                //     nextDay: '[Yfory am] LT',
                //     nextWeek: 'dddd [am] LT',
                //     lastDay: '[Ddoe am] LT',
                //     lastWeek: 'dddd [diwethaf am] LT',
                //     sameElse: 'L',
                // },
                // relativeTime: {
                //     future: 'mewn %s',
                //     past: '%s yn ôl',
                //     s: 'ychydig eiliadau',
                //     ss: '%d eiliad',
                //     m: 'munud',
                //     mm: '%d munud',
                //     h: 'awr',
                //     hh: '%d awr',
                //     d: 'diwrnod',
                //     dd: '%d diwrnod',
                //     M: 'mis',
                //     MM: '%d mis',
                //     y: 'blwyddyn',
                //     yy: '%d flynedd',
                // },
                // dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
                // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
                // ordinal: function (number) {
                //     var b = number,
                //         output = '',
                //         lookup = [
                //             '',
                //             'af',
                //             'il',
                //             'ydd',
                //             'ydd',
                //             'ed',
                //             'ed',
                //             'ed',
                //             'fed',
                //             'fed',
                //             'fed', // 1af to 10fed
                //             'eg',
                //             'fed',
                //             'eg',
                //             'eg',
                //             'fed',
                //             'eg',
                //             'eg',
                //             'fed',
                //             'eg',
                //             'fed', // 11eg to 20fed
                //         ];
                //     if (b > 20) {
                //         if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                //             output = 'fed'; // not 30ain, 70ain or 90ain
                //         } else {
                //             output = 'ain';
                //         }
                //     } else if (b > 0) {
                //         output = lookup[b];
                //     }
                //     return number + output;
                // },
                week: {
                    dow: 1, // Monday is the first day of the week.
                    doy: 4, // The week that contains Jan 4th is the first week of the year.
                }
            })
        } else {
            moment.updateLocale(ajax_client.current_lang, { weekdaysMin: 'S_M_T_W_T_F_S'.split('_') });
        }

        // console.log(ajax_client.current_lang)
        // console.log('cal:days::', props.days)

        this.dates = []

        this.days = Array.from(props.days.by('day'))

        // console.log(this.days)

        for (let item of this.days) {

            let day = moment(item).format('YYYY-MM-DD')

            // console.log('CAL DATE', props.calendar[day])

            let date = {
                day: moment(item),
                items: props.calendar[day] ? props.calendar[day].items : null,
                class: props.calendar[day] ? props.calendar[day].types.join(' ') : 'disabled'
            }

            date.class += ' day';

            if ( moment(item).format('dd') == 'S' ) {
                date.class += ' weekend';
            }

            this.dates.push(date)
        }


        // console.log('DATES', this.dates)
    }


    render() {


        return (
            <div class="month--day">
                {this.dates.map((item, index) => (

                    <div className={item.class} onClick={(e) => this.props.onClickDay(e, item.day.format('YYYY-MM-DD'), item.items)}>
                        <span class="day-dd">{ item.day.format('dd') }</span>
                        <span>{ item.day.format('D') }</span>
                        <span class="icon-diamond first"></span>
                        <span class="icon-diamond second"></span>
                    </div>

                ))}
            </div>
        )
    }

}



class Month extends Component {

    constructor(props) {

        super(props)

        // console.log(props)

        const month = props.month.format('D MMMM YYYY')
        // console.log('month::', month)
        const start = moment(month).isSame(moment(), 'month') ? moment() : moment(month).startOf('month')
        const end   = moment(month).endOf('month')

        this.month = props.month.format('MMMM')
        this.year  = props.month.format('YYYY')
        this.days  = moment.range(start, end)

        this.localeMonths = {


            'January': 'Ionawr',
            'February': 'Chwefror',
            'March': 'Mawrth',
            'April': 'Ebrill',
            'May': 'Mai',
            'June': 'Mehefin',
            'July': 'Gorffennaf',
            'August': 'Awst',
            'September': 'Medi',
            'October': 'Hydref',
            'November': 'Tachwedd',
            'December': 'Rhagfyr'
        }
    }


    render() {

        return (
            <div class="month">
                <span class="month--name">{(ajax_client.current_lang == 'cy')? this.localeMonths[this.month] : this.month} {this.year}</span>
                <div class="month--days">
                    <Days
                        calendar={this.props.calendar}
                        days={this.days}
                        onClickDay={this.props.onClickDay}
                    />
                </div>
            </div>
        )
    }

}


class Months extends Component {

    constructor(props) {

        super(props)

        this.months = Array.from(props.range.by('month'))

        // console.log('STATE CAL', props.calendar)
        // console.log('months::', this.months)

    }


    render() {

        return (
            <div class="calendar-dates">
                {this.months.map((item, index) => (
                    <Month
                        calendar={this.props.calendar}
                        month={item}
                        onClickDay={this.props.onClickDay}
                    />
                ))}
            </div>
        )
    }

}

class Calendar extends Component {

    constructor() {

        super()

        this.api = ajax_client ? ajax_client.spektrix_api_url : location.href.match(/org.uk/) ? 'https://livedomain/rsno/api/v3/' : 'https://system.spektrix.com/shermantheatre_run2/api/v3/'

        const start = moment().utc()
        const end   = moment().utc().add(4, 'months')

        const range = moment.range(start, end)

        // console.log('calendar range:::', range)

        this.getCalendar = this.getCalendar.bind(this)
        this.getEvents = this.getEvents.bind(this)

        this.state = {
            start: start.format('YYYY-MM-DD'),
            end: end.format('YYYY-MM-DD'),
            range: range,
            calendar: [],
            events: []
        }


    }

    componentDidMount() {

        // this.setState({
        //     isLoaded: true,
        // })

        this.getCalendar()
    }

    getCalendar() {

        var _this = this

        // console.log('GET CALENDAR')

        let access = $('#events-filters-accessibility').length

        $.post(window.ajax_client.ajax_url, {

            'action': 'spektrix_calendar',
            'accessibility': access,
            'dates': {
                start: _this.state.start,
                end: _this.state.end
            }

        }, function(response){

            if (response) {

                var calendar = JSON.parse(response)

                var date = Object.keys(calendar).shift()
                var start = moment(date).utc()
                var end = moment(start).utc().add(2, 'months')

                const range = moment.range(start, end)

                // console.log('ajax range::', range)

                _this.setState({
                    isLoaded: true,
                    calendar: calendar,
                    start: start,
                    end: end,
                    range: range
                })
            }

        })
    }


    getEvents(event, date, items) {

        var _this = this

        // console.log('GET EVENTS')
        // console.log(date, items)

        let el = event.currentTarget

        if (! el.classList.contains('disabled') ) {
            document.querySelectorAll('.selected').forEach( el => el.classList.remove('selected') )
            el.classList.add('selected')


            $.post(window.ajax_client.ajax_url, {

                'action': 'calendar_events',
                'events': items

            }, function(response){

                if (response) {

                    if ( $('#events-carousel-wrap').length ) {
                        $('#events-carousel-wrap').triggerHandler('items-reloaded', $(response))
                    } else if ( $('#events-listing').length ) {
                        $('#events-listing').triggerHandler('items-reloaded', { date: date, items: items, response: $(response)})
                    }

                }

            })
        }
    }


    events_panel(event){

        var el = event.currentTarget
        // console.log(el)

        $('.calendar--events').html('').hide('fast')
        $(el).hide()
    }


    scroll(event, direction){

        var dir = direction == 'left' ? '-=' : '+='
        var scroll_amount = 300

        $('.calendar-dates').animate({
            scrollLeft: dir + scroll_amount
        }, 500, 'linear', function(){

            if ($('.calendar-dates').scrollLeft() > 0) {
                $('.scroll-left').addClass('active')
            } else {
                $('.scroll-left').removeClass('active')
            }

            if ($('.calendar-dates').scrollLeft() + $('.calendar-dates').outerWidth() < $('.calendar-dates')[0].scrollWidth) {
                $('.scroll-right').addClass('active')
            } else {
                $('.scroll-right').removeClass('active')
            }

        })


    }

    render() {

        if (ajax_client.current_lang == 'cy') {
            moment.locale(ajax_client.current_lang, {
                // months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
                //     '_'
                // ),
                // monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
                //     '_'
                // ),
                weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                    '_'
                ),
                weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
                weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
                weekdaysParseExact: true,
                week: {
                    dow: 1, // Monday is the first day of the week.
                    doy: 4, // The week that contains Jan 4th is the first week of the year.
                }
            })
        }


        if (this.state.isLoaded) {

            return (

                <div>
                    <button class="toggle-events" onClick={(e) => this.events_panel(e)}><span class="icon-close"></span></button>
                    <button class="scroll scroll-left" onClick={(e) => this.scroll(e, 'left')}><span class="icon-chevron-left"></span></button>

                    <Months
                        calendar={this.state.calendar}
                        range={this.state.range}
                        onClickDay={this.getEvents}
                    />

                    <button class="scroll scroll-right active" onClick={(e) => this.scroll(e, 'right')}><span class="icon-chevron-right"></span></button>

                </div>

            )

        } else {

            return (<div></div>)
        }
    }
}

export default Calendar;

const wrapper = document.getElementById('calendar')
wrapper ? ReactDOM.render(<Calendar />, wrapper) : false